import React, { useEffect } from 'react';
import { Alert, Button, Text } from '@perch-labs/shrike';
import {
  getAmerenRedirectUri,
  API_TOKEN_UTILITY_PORTAL_MAP,
} from 'domain/utility-credentials';
import { copyFor, routes } from 'config';
import { useSearchParam } from 'hooks/use-search-param.hook';
import { useUpdateUtilityCredential } from 'hooks/use-update-utility-credential-hook';

const getCopy = copyFor('settings.utilitySyncEdit.ameren');
const getErrorCopy = copyFor('errors.server');
const { utilitySync } = routes();

interface Props {
  utilityCredentialId: number;
  utilityId: number;
  isSynced: boolean;
}

export const ApiToken = ({
  utilityId,
  utilityCredentialId,
  isSynced,
}: Props) => {
  const paramError = useSearchParam('error');

  const code = useSearchParam('code');

  const [{ error: mutationError, loading }, submit] =
    useUpdateUtilityCredential({
      redirectRoute: utilitySync,
      utilityCredential: {
        id: utilityCredentialId,
        password: code,
        redirectUri: getAmerenRedirectUri(),
      },
    });

  const error = !!paramError || !!mutationError;
  const sendToPortal = () => {
    window.location.href = API_TOKEN_UTILITY_PORTAL_MAP[utilityId];
  };

  useEffect(() => {
    if (code && !loading && !error) submit();
  }, [code, error, loading, submit]);

  return (
    <>
      <Text margin={{ bottom: '32px' }}>
        {getCopy(isSynced ? 'descriptionSynced' : 'description')}
      </Text>
      <Button
        fullWidth
        margin={{ bottom: '16px' }}
        onClick={sendToPortal}
        loading={loading}
        type="submit"
      >
        {getCopy(`buttons.${isSynced ? 'resync' : 'sync'}`)}
      </Button>
      {error && <Alert>{getErrorCopy('generic')}</Alert>}
    </>
  );
};
